import React from "react";
import "./styles.less";
import { Button } from "../../components/Button";
import { useTranslation } from "react-i18next";
import { CommonConsult } from "../../blocks/common-consult";
import { tryNow } from "../../utils";

export const CustomerConsult = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="customer-consult">
        <div className="customer-consult-bg">
          <img
            src={"//files.authing.co/authing-website/tryblock-bg-img.png"}
            alt="authing customer"
          />
        </div>
        <div className="inner">
          <div className="content-warp">
            <div className="slogin">{t("common.common-customer")}</div>

            <div
              style={{ display: "flex" }}
              className="customer-consult-button-warp"
            >
              <CommonConsult
                aside={
                  <Button
                    style={{
                      background: "none",
                      color: "#396aff",
                      border: "1px solid #396aff",
                      marginRight: 20,
                    }}
                  >
                    {t("common.common-consult")}
                  </Button>
                }
              />
              <div className="" onClick={tryNow}>
                <Button>{t("common.common-button-立即试用")}</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
